module.exports = __webpack_public_path__ + "i18n/es.b032347612629e381c2675b2d65bbbe8.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/es.json
// module id = 1307
// module chunks = 59